import { moduleLogger } from "../Logger";
import { sendLog } from "@otto-ec/global-resources/debug";
import type { DetailviewBenefit } from "../benefit/DetailviewBenefit";

const log = moduleLogger.scope("api-client");

export class ApiClient {
	async getBestMatchBenefit(variationId: string, productId?: string, autoActivateBenefitId?: string): Promise<DetailviewBenefit | undefined> {
		let path = `/benefit-detailview/benefits?variationId=${variationId}`;

		if (productId) {
			path = `${path}&productId=${productId}`;
		}
		if (autoActivateBenefitId) {
			path = `${path}&benefitId=${autoActivateBenefitId}`;
		}
		const response = await fetch(path, {
			headers: { "X-Requested-With": "XMLHttpRequest" },
		});
		if (response.status === 204) {
			log.info("[benefit-detailview] benefits endpoint returns 204 as status code, variation not found in database or no benefits found for current user on passed variation.");
			return undefined;
		}

		if (response.status !== 200) {
			log.error(`[benefit-detailview] benefits endpoint returns a non ok response! ${response.status}`);
			return undefined;
		}
		const json = await response.text();

		return JSON.parse(json, (key: string, value: string) => {
			if (key === "activeUntil") return new Date(value);
			return value;
		}) as DetailviewBenefit;
	}

	async getBounceCinema(benefitId: string): Promise<string> {
		const response = await fetch(`/benefit-cinema/bounce?benefit_id=${benefitId}`, {
			headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
		});

		if (response.status !== 200) {
			log.warn(`[benefit-detailview] bounce endpoint returns a non ok response! ${response.status}`);
			sendLog("ft9-benefit-detailview-bounce-non-200", {
				benefit_id: benefitId,
				status_code: response.status,
			});
			return "";
		}
		return response.text();
	}
}
